import { gql } from "@apollo/client";

const SAVE_INTEGRATION_MUTATION = gql`
  mutation save_integration(
    $id: String
    $integration_type: String
    $authorization: GenericScalar
    $configuration: GenericScalar
    $filters: [IntegrationFilterInput]
  ) {
    save_integration(
      id: $id
      integration: {
        integration_type: $integration_type
        authorization: $authorization
        configuration: $configuration
        filters: $filters
      }
    ) {
      ok
      integration {
        id
        integration_type
        public_authorization
        configuration
        status
        filters {
          id
          production
          backfills
          proofs
          lateUploads
          beta
          configuration
          status
        }
        assistance
      }
    }
  }
`;

const REMOVE_INTEGRATION_MUTATION = gql`
  mutation remove_integration($id: String!) {
    remove_integration(id: $id) {
      ok
    }
  }
`;

export { REMOVE_INTEGRATION_MUTATION, SAVE_INTEGRATION_MUTATION };
